if (!customElements.get("mask-drawer")) {
    customElements.define(
        "mask-drawer",
        class MediaGallery extends HTMLElement {
            constructor() {
                super();
                this.sectionId = this.dataset.sectionId;
                this.enableSlide();
                this.addEventListener("change", this.onChange.bind(this));
            }
            onChange(e) {
                const btn = document.querySelector(`[data-modal="${this.dataset.modal}"]`);
                const dataElement = e.target.nextElementSibling;
                const img = dataElement.querySelector("img");
                const type = dataElement.querySelector("h5");
                const title = dataElement.querySelector("p");
                btn.classList.add("no-msg");
                btn.querySelector(".mask-modal__img").innerHTML = img.outerHTML;
                btn.querySelector(".mask-modal__title").innerHTML = `<p>${type.innerText}</p><p>${title.innerText}</p>`;
                btn.querySelector(".mask-modal__link").innerHTML = "Edit";
                const elmCheckMask = document.querySelectorAll(`[data-section-id="${this.sectionId}"] .js-check-mask`);
                elmCheckMask.forEach((elm) => elm.classList.remove("js-check-mask"));
            }
            enableSlide() {
                this.swiperThumbs = new Swiper(this.querySelector(".js-mask-header"), {
                    slidesPerView: "auto",
                    spaceBetween: 20,
                    watchOverflow: true,
                    navigation: {
                        nextEl: this.querySelector(".swiper-button-next"),
                        prevEl: this.querySelector(".swiper-button-prev"),
                    },
                });
                this.swiperMain = new Swiper(this.querySelector(".js-mask-body"), {
                    slidesPerView: 1,
                    effect: "fade",
                    thumbs: {
                        swiper: this.swiperThumbs,
                    },
                });
            }
        }
    );
}
